import { useEffect, useState } from 'react';
import {
  THEME_CHANGE_EVENT,
  getEffectiveTheme,
  getStoredThemeMode,
} from '../config/themeMode';

export function useAppTheme() {
  const [state, setState] = useState(() => {
    const mode = getStoredThemeMode();
    return { mode, effective: getEffectiveTheme(mode) };
  });

  useEffect(() => {
    const onThemeChange = (event) => {
      const { mode, effective } = event.detail;
      setState({ mode, effective });
    };

    window.addEventListener(THEME_CHANGE_EVENT, onThemeChange);
    return () => window.removeEventListener(THEME_CHANGE_EVENT, onThemeChange);
  }, []);

  return {
    mode: state.mode,
    effectiveTheme: state.effective,
    isLight: state.effective === 'light',
    isDark: state.effective === 'dark',
  };
}
